import { render, staticRenderFns } from "./NearestBranchBox.vue?vue&type=template&id=6523026f&scoped=true"
import script from "./NearestBranchBox.vue?vue&type=script&lang=js"
export * from "./NearestBranchBox.vue?vue&type=script&lang=js"
import style0 from "./NearestBranchBox.vue?vue&type=style&index=0&id=6523026f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6523026f",
  null
  
)

export default component.exports